import type {
  RadioGroupSlots as RadioGroupBaseSlots,
  RadioGroupBaseProps,
  RadioGroupBaseState,
  RadioGroupContextValues as RadioGroupContextValuesBase,
} from '@fluentui/react-radio';

/**
 * RadioGroup component slots
 */
export type RadioGroupSlots = RadioGroupBaseSlots;

/**
 * RadioGroup component props
 */
export type RadioGroupProps = RadioGroupBaseProps;

/**
 * RadioGroup component state
 */
export type RadioGroupState = RadioGroupBaseState;

/**
 * RadioGroup component context values
 */
export type RadioGroupContextValues = RadioGroupContextValuesBase;
